import React, { useEffect, useState, useRef } from "react";
import Lottie from "lottie-react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DeliveryPickUpWidget from "../../DeliveryPickUpWidget/DeliveryPickUpWidget";
import { amplitudeDeliveryWidgetPageSection } from "../../../shared/constants/amplitudeDeliveryWidgetPageSections";

const MapPinIcon = require("./icons/map-pin.svg");
const bakeryAnimation = require("./icons/bakery.json")
const truckAnimation = require("./icons/truck.json")

function Delivery(props) {
  const {
    userAddress,
    showWidget,
    setShowDeliveryWidget,
    analyticsPageSection,
  } = props;
  const resolvedAnalyticsSection =
    analyticsPageSection ||
    amplitudeDeliveryWidgetPageSection.belowHero;
  const [addressType, setAddresType] = useState("delivery");
  const deliveryButtonRef = useRef(null);
  const disableCssClass =
    " opacity-60 bg-opacity-60 border-opacity-60 text-opacity-60";
  const hoverCssClass =
    " hover:opacity-100 hover:bg-opacity-100 hover:border-opacity-100 hover:text-opacity-100";

  const [showModal, setShowModal] = useState(showWidget);

  useEffect(() => {
    setShowModal(showWidget);
  }, [showWidget]);

  const onCloseWidget = () => {
    setShowModal(false);
    setShowDeliveryWidget(false);
    // Return focus to the delivery button when widget closes
    if (deliveryButtonRef.current) {
      deliveryButtonRef.current.focus();
    }
  };

  const onOpenWidget = (type) => {
    setAddresType(type);
    setShowModal(true);
    if (typeof setShowDeliveryWidget === "function") {
      setShowDeliveryWidget(
        true,
        amplitudeDeliveryWidgetPageSection.belowHero
      );
    }
    // Focus will be managed by the DeliveryPickUpWidget modal when it opens
  };

  return (
    <>
      {!userAddress ? (
        <div className="md:flex items-center flex-col gap-4 lg:w-2/5 w-full mx-auto mt-14 hidden">
          <div className="flex gap-4 w-full lg:w-96 px-4 lg:px-0  item-center justify-center">
            <button
              ref={deliveryButtonRef}
              type="button"
              onClick={() => onOpenWidget("delivery")}
              aria-pressed={addressType === "delivery"}
              aria-label="Delivery - Select to enter delivery address"
              className={`
              flex flex-col justify-center items-center shadow-lg
              rounded-[12px]
              w-[167px] h-[128px]  gap-1 bg-transparent 
              text-dark dark:text-white
              font-montserratBold
              ${addressType === "delivery" ? "opactity-100 font-bold" : disableCssClass}
              ${hoverCssClass}
            `}
            >
              <div className="w-[88px]" aria-hidden="true">
                {addressType === "delivery" ? (
                  <Lottie animationData={truckAnimation} autoPlay loop />
                ) : (
                  <Lottie autoplay={false} animationData={truckAnimation} />
                )}
              </div>

              <p>Delivery</p>
            </button>
            <button
              type="button"
              onClick={() => onOpenWidget("pickup")}
              aria-pressed={addressType === "pickup"}
              aria-label="Pickup - Select to enter pickup location"
              className={`
            flex flex-col justify-center items-center shadow-lg
            rounded-[12px]
            w-[167px] h-[128px]  gap-1 bg-transparent 
            text-dark dark:text-white
            font-montserratBold
              ${addressType === "pickup" ? "opactity-100 font-bold" : disableCssClass}
              ${hoverCssClass}
            `}
            >
              <div className="w-[88px]" aria-hidden="true">
                {addressType === "pickup" ? (
                  <Lottie animationData={bakeryAnimation} autoPlay loop />
                ) : (
                  <Lottie autoplay={false} animationData={bakeryAnimation} />
                )}
              </div>

              <p>Pickup</p>
            </button>
          </div>
          <div
            id="input_delivery_address"
            className="w-full px-4 lg:px-0 cursor-pointer"
            onClick={() => {
              setShowModal(true);
              if (typeof setShowDeliveryWidget === "function") {
                setShowDeliveryWidget(
                  true,
                  amplitudeDeliveryWidgetPageSection.belowHero
                );
              }
            }}
            onKeyDown={event => {
              if (event.key === "Enter") {
                setShowModal(true);
                if (typeof setShowDeliveryWidget === "function") {
                  setShowDeliveryWidget(
                    true,
                    amplitudeDeliveryWidgetPageSection.belowHero
                  );
                }
              }
            }}
            role="button"
            tabIndex={0}
            aria-label={`Enter ${addressType} address`}
          >
            <div
              className="flex flex-row items-center
            gap-3 h-11 border border-pink-50 dark:border-mainDark
            rounded-[54px] py-3 px-4 w-full bg-white text-dark dark:text-white
            leading-5 dark:bg-gradient-r dark:bg-gradient-to-l dark:from-darkBlack dark:to-darkBlack"
            >
              <img src={MapPinIcon} alt="" className="w-5 h-5" />
              <p id="input_placeholder_text">{`Enter ${addressType} address`}</p>
            </div>
          </div>
          <div className="w-full px-4 lg:px-0 text-center">
            <p className="w-full text-center text-darkElevationPrimary dark:text-darkElevationSecondary ">
              {addressType === "pickup"
                ? "Fresh, warm cookies ready for pickup"
                : "Fresh, warm cookies delivered right to your door"}
            </p>
          </div>
        </div>
      ) : null}
      <div id="deliveryPickUpWidget">
        {showModal ? (
          <DeliveryPickUpWidget
            onClose={onCloseWidget}
            onAddressType={setAddresType}
            addressType={addressType}
            analyticsPageSection={resolvedAnalyticsSection}
          />
        ) : null}
      </div>
    </>
  );
}

Delivery.propTypes = {
  productId: PropTypes.any, // eslint-disable-line
  userOrderMethod: PropTypes.string, // eslint-disable-line
  userAddress: PropTypes.shape({ address1: PropTypes.string }),
  showWidget: PropTypes.bool,
  setShowDeliveryWidget: PropTypes.func,
  analyticsPageSection: PropTypes.string,
};

Delivery.defaultProps = {
  productId: null,
  userOrderMethod: "",
  userAddress: null,
  showWidget: false,
  setShowDeliveryWidget: null,
  analyticsPageSection:
    amplitudeDeliveryWidgetPageSection.belowHero,
};

export const mapStateToProps = state => {
  const {
    userToken,
    userAddress,
    userCartId,
    userOrderMethod,
    userCart,
    selectedStore
  } = state.user;
  const { isShippingActive } = state.shipping;
  const {
    selectedCountry,
    allCountries,
    isCountrySelectActive
  } = state.country;
  return {
    userToken,
    userAddress,
    userCartId,
    userOrderMethod,
    userCart,
    selectedStore,
    isShippingActive,
    selectedCountry,
    allCountries,
    isCountrySelectActive
  };
};

export default withRouter(connect(mapStateToProps, null)(Delivery));
